import React from 'react';
import { Alert, AlertTitle, alertClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled Alert component
const StyledAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: '#FEF2F2', // red-50
    color: '#B91C1C',           // red-600
    border: '1px solid #FECACA', // red-200
    alignItems: 'flex-start',
    fontSize: '0.875rem',
    borderRadius: theme.shape.borderRadius,
    [`& .${alertClasses.title}`]: {
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
    },
}));

const LoginErrorAlert = ({
    loginError,
    closeErrorAlert,
}) => {
    if (!loginError) return null;

    return (
        <StyledAlert severity="error" onClose={closeErrorAlert}>
            <AlertTitle>Error</AlertTitle>
            {loginError}
        </StyledAlert>
    );
};

export default LoginErrorAlert;
